import url from '@/shared/lib/url';
import { useRouter } from '@tanstack/react-router';
import { FC } from 'react';
import { cteatedEditButtonStyles, deleteButtonStyles } from './styles';
import { CreatedDeleteButton } from '@/features/delete';
import { PublishButton } from '@/features/publish';
import { CreatedEditButton } from '@/features/edit/ui/created-edit-button';
import { difyMap } from '@/shared/utils/created';

interface CreatedBoxCardProps {
    data: DATA.Exam;
    index: number;
    checked: boolean;
    handleCheck: (data: DATA.Exam) => void;
    onSelect: (data: DATA.Exam) => void;
    onRefetch: () => void;
}

export const CreatedBoxCardType: FC<CreatedBoxCardProps> = ({
    data,
    checked,
    handleCheck,
    onRefetch,
}) => {
    const router = useRouter();
    const goToCreatedDetail = () => {
        const examId = data.examId;
        router.navigate({ to: `/sets/created-box/detail/${examId}` });
    };

    type Grouped = Record<string, number>;
    const grouped = data?.articleTypeList.reduce((acc, { articleType, articleTypeCnt }) => {
        const groupKey = articleType === '문항' || articleType === '활동' ? '문항' : articleType;
        acc[groupKey] = (acc[groupKey] || 0) + articleTypeCnt;
        return acc;
    }, {} as Grouped);

    // 객체를 배열의 객체 형태로 변환
    const articleCountArray = Object.entries(grouped).map(([articleType, articleTypeCnt]) => ({
        articleType,
        articleTypeCnt,
    }));

    return (
        <li>
            <span className="label-wrap">
                {data.difyNm && data?.curriSubject === 'mathematics' && (
                    <span className={`viewlabel1 ${difyMap[data?.difyNm]}`}>{data.difyNm}</span>
                )}
                {/* {articleCountArray?.map((e, i) => (
                    <span key={`card-articleType-${i}`} className="viewlabel2">
                        {e.articleType} {e.articleTypeCnt}개
                    </span>
                ))} */}
                <span key={`card-articleType-${0}`} className="viewlabel2">
                    {'문항'} {data.mdulCnt}개
                </span>
            </span>
            <span className="chk">
                <input
                    type="checkbox"
                    id={`chk1-${data.examId}`}
                    name="chk"
                    value={data.examId}
                    checked={checked}
                    onChange={() => handleCheck(data)}
                />
                <label htmlFor={`chk1-${data.examId}`}>
                    <i></i>
                </label>
            </span>
            <button type="button" className="thumb" onClick={goToCreatedDetail}>
                <img src={url.src(data.thumbnail) ?? ''} alt="thumbnail" />
                {/* <div className="preview-layer">
                    <div className="preview">
                        <img src={url.src(data.thumbnail) ?? ''} alt="thumbnail" />
                    </div>
                </div> */}
            </button>
            <div className="info">
                <button type="button" className="data-title" onClick={goToCreatedDetail}>
                    {data.name}
                </button>
                <div className="btm-info ttukttak">
                    <CreatedDeleteButton
                        checkList={[data.examId.toString()]}
                        showTooltip={true}
                        styles={deleteButtonStyles}
                        onRefetch={onRefetch}
                    />
                    {/* <button type="button" className="btn btn-icon modify-edit">
                        <span className="tooltip">편집</span>
                    </button> */}
                    <CreatedEditButton
                        examId={data.examId}
                        examName={data.name}
                        showTooltip={true}
                        styles={cteatedEditButtonStyles}
                        onRefetch={onRefetch}
                        examSetId={data.setsId}
                        curriBook={data.curriBook}
                        subjectId={data.curriSubjectId}
                        textbookId={data.textbkId}
                    />
                    <PublishButton
                        checkList={[data]}
                        showTooltip={true}
                        styles={{ button: 'btn btn-icon modify-publication' }}
                    />
                </div>
            </div>
        </li>
    );
};
